/* eslint-disable import/prefer-default-export */
export const loginModalUrls = [
  '/',
  '/explore',
  '/goal/[goalSlug]/[goalUID]',
  '/class/[slug]/[uid]',
  '/course/[slug]/[courseUID]',
  '/test-series/[slug]/[courseUID]'
];
